import { TokenConstants } from '../types';

const tokens: TokenConstants = {
  Popular: {
    Symbols: ['BURR', 'USDC'],
  },
  InitialSwapTokens: {
    input: '0x90187b7315645a46682d8604EbB40e18Bfd07F77', // BURR
    output: '0x1F6A0b5659B11144d0e9F0A99184981815AFdD23', // USDC
  },
  Addresses: {
    nativeAsset: '0x0000000000000000000000000000000000000000', // BERA
    wNativeAsset: '0x2ec8DeB018B85274Feb514d15ed7566Ba50DAbe6', // WBERA
    WETH: '0x137Df25cAbf220A180300604E57551AC1397959d',
    BAL: '0x90187b7315645a46682d8604EbB40e18Bfd07F77',
  },
  Permissionless: {
    baseTokens: [],
    quoteTokens: [],
  },
};

export default tokens;
